import {createUseStyles} from 'react-jss';
export default createUseStyles({
  card: {
    width: 200,
    height: 100,
    border: '2px solid rgba(0,0,0,0.6)',
    borderRadius: 10,
    cursor: 'pointer',
    display:'flex',
    flexDirection :'column',
    justifyContent: 'space-between',
    padding: 10,
    
    fontSize: 12,
    color: 'black',
    textDecoration:'none', 
    margin: '20px',
    
    '& span': {
      display: 'flex',
      fontWeight: 'bold',
      fontSize: 15,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },
    '& div': {
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }
  },

  '@media screen and (max-width: 500px)': {
    card: {
      width: '100%'
    }
  
  },
})